// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-wrapper-cbYwaD{width:100%}.select-wrapper-cbYwaD .semi-select-disabled .semi-select-arrow{color:rgba(29,28,35,.6)}.select-wrapper-cbYwaD span{width:100%}.error-wrapper-_ZgJx2 .semi-select{border:1px solid #f93920}.error-content-TD7d74{height:20px}.error-float-lSPXTk{width:100%;position:absolute}.error-text-bm_wVC{color:#f93920;padding-top:2px;font-size:12px;position:absolute}.selected-option-FTHMPv .semi-select-option-selected .semi-select-option-icon{color:#4d53e8}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select-wrapper": `select-wrapper-cbYwaD`,
	"selectWrapper": `select-wrapper-cbYwaD`,
	"error-wrapper": `error-wrapper-_ZgJx2`,
	"errorWrapper": `error-wrapper-_ZgJx2`,
	"error-content": `error-content-TD7d74`,
	"errorContent": `error-content-TD7d74`,
	"error-float": `error-float-lSPXTk`,
	"errorFloat": `error-float-lSPXTk`,
	"error-text": `error-text-bm_wVC`,
	"errorText": `error-text-bm_wVC`,
	"selected-option": `selected-option-FTHMPv`,
	"selectedOption": `selected-option-FTHMPv`
};
export default ___CSS_LOADER_EXPORT___;
